import { createApp } from "vue";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import More from "highcharts/highcharts-more";
import stockInit from "highcharts/modules/stock";
// import mapInit from "highcharts/modules/map";
More(Highcharts);
stockInit(Highcharts);
// mapInit(Highcharts);

import "@/assets/css/front/icon.css";
import "@/assets/css/flag-icon.min.css";
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
library.add(fas);
import { fab } from "@fortawesome/free-brands-svg-icons";
library.add(fab);
import { far } from "@fortawesome/free-regular-svg-icons";
library.add(far);
dom.watch();
window.$ = window.jQuery = require("jquery");
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@/assets/css/front/newFront.css";
import dynvibewordcloud from "@/components/vueCharts/DynvibeWordCloud.vue";
import bigstory from "@/components/posts/bigStory.vue";
const app = createApp(App);

// global variables / function for all components
// usage for axios : this.$axios
const moment = require("moment");
import axios from "axios";
import Qs from "qs";
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$Qs = Qs;
app.config.globalProperties.$moment = moment;
// app.config.compilerOptions.isCustomElement = (tag) => tag === "dynvibewordcloud";
// TODO : config file for DEV / PROD ?
app.config.globalProperties.$backendUrl =
	process.env.NODE_ENV == "development" ? "http://dev.detect.com/detect/" : "https://detect.dynvibe.com/detect/";

import mixin from "@/mixins/mixin.js";
app.mixin(mixin);
app.provide("picture_host", "https://unruffled-sutherland.46-21-195-69.plesk.page/img/instagram_images/");
app.component("font-awesome-icon", FontAwesomeIcon);
app.component("dynvibewordcloud", dynvibewordcloud);
app.component("bigstory", bigstory);
app.use(store).use(router).use(HighchartsVue).mount("#app");

console.log(process.env.NODE_ENV);
